const numberOr = (replaceValue = null) => (item) => {
  const value = typeof item === 'object' ? item.value : item;
  const parsedVal = parseFloat(value?.toString().replace(/,|\s/g, ''));
  return Number.isNaN(parsedVal) ? replaceValue : parsedVal;
};

export default numberOr;
